/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbContactSummary
 */
export interface HchbContactSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    contact_name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    contact_type?: string;
}

/**
 * Check if a given object implements the HchbContactSummary interface.
 */
export function instanceOfHchbContactSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "contact_name" in value;

    return isInstance;
}

export function HchbContactSummaryFromJSON(json: any): HchbContactSummary {
    return HchbContactSummaryFromJSONTyped(json, false);
}

export function HchbContactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbContactSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contact_name': json['contact_name'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
    };
}

export function HchbContactSummaryToJSON(value?: HchbContactSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'contact_name': value.contact_name,
        'contact_type': value.contact_type,
    };
}

